import {action, computed, makeObservable} from "mobx";

import {HttpError} from "../../../api/http-error";
import {CategoryGroupInput} from "../../../api/values/category-group-create-input";
import {CategoryInputOutput} from "../../../api/values/category-input-output";
import {Stores} from "../../../stores";
import {Permission} from "../../../stores/authentication-store";
import {CategoryGroupFormStore} from "../../../stores/cagegory-group-form-store";
import dayjs from "../../../utils/dayjs";
import {PageStoreConstructorOptions} from "../../../utils/page-store";

// 作成・編集で使うCategoryGroupFormStoreを継承
export class CategoryGroupCreatePageStore extends CategoryGroupFormStore {
    private adminApi;
    private pageRouter;
    private mediaId: string = "";
    private stores: Stores;
    constructor(options: PageStoreConstructorOptions) {
        super();
        makeObservable(this);
        this.adminApi = options.adminApi;
        this.pageRouter = options.pageRouter;
        this.stores = options.stores;
    }

    public async initialize({query}: {query: {mediaId: string}}) {
        this.stores.authenticationStore.checkAnyPermissionExists(
            Permission.MANAGE_SYSTEM,
            Permission.MANAGE_MEDIA,
        );
        this.setMediaId(query.mediaId || "");
    }

    @action.bound
    public setMediaId(mediaId: string) {
        this.mediaId = mediaId;
    }

    @action.bound
    public async createCategoryGroup() {
        const now = dayjs().tz("Asia/Tokyo").format();
        const dto = new CategoryGroupInput({
            slug: this.groupSlug,
            label: this.groupLabel,
            categories: this.tableRows.map(
                (r) => new CategoryInputOutput({slug: r.slug, label: r.label, createdAt: now}),
            ),
        });

        try {
            await this.adminApi.postCategoryGroups({mediaId: this.mediaId}, dto);
            this.pageRouter.pushRoute(`/admin/${this.mediaId}/category-groups`);
        } catch (error) {
            if (error instanceof HttpError) {
                console.error(error.message);
                this.duplicateError = error.message;
            }
        }
    }

    @computed
    public get canCreate() {
        return super.canSave();
    }
}
